import React from 'react';
import PropTypes from 'prop-types';
import {withRouter, NavLink as RouterLink,NavLink } from 'react-router-dom';
import { Tooltip } from 'reactstrap';
import './index.css'


 class CircularButtonGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        tooltipOpen: false,
        activeToolTipId: null
        };
      }

    toggle = () => {        
        this.setState({
            tooltipOpen: !this.state.tooltipOpen
        });
    }

    toggleMultiple = (e,id) => {
        this.setState({tooltipOpen: false,activeToolTipId: null},() => {
            this.setState({tooltipOpen: !this.state.tooltipOpen,activeToolTipId: id},() => {
                if(e.type == 'mouseout'){
                    this.setState({tooltipOpen: false})
                }
            })
        })
    }

    render() {
        const { buttonGroupData,singleButton, swotCatagory, toolTip } = this.props
        if(singleButton) {
            return (
                <div className={`d-flex ${this.props.textAlign == undefined ? "justify-content-center" : this.props.textAlign} align-items-center ${this.props.show_button_group_container_class ? this.props.show_button_group_container_class : 'swot-button-group-single'}`}>

                        {
                            buttonGroupData.map((val, key) => {
                                if(val.id == swotCatagory) {
                                    if(this.props.uncontrolledButton != undefined || this.props.uncontrolledButton == true) {
                                        return (
                                            <div className="swot-nav-link " id="TooltipExample222" style={{backgroundImage: `url(${val.img})`}} key={key}>
                                                {
                                                    toolTip == undefined || toolTip == true ?
                                                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipExample222" toggle={() => this.toggle()} delay={{ show: 0, hide: 5 }}>
                                                        {val.name} 
                                                    </Tooltip>:
                                                   null
                                                }
                                            </div>
                                        ) 
                                    }
                                    else {                                      
                                        return (
                                            <NavLink to={val.link} className="swot-nav-link " id="TooltipExample222" style={{backgroundImage: `url(${val.img})`}} key={key}>
                                                {
                                                    toolTip == undefined || toolTip == true ?
                                                    <Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipExample222" toggle={() => this.toggle()} delay={{ show: 0, hide: 5 }}>
                                                        {val.name} 
                                                    </Tooltip>:
                                                   null
                                                }
                                            </NavLink>
                                        )
                                    }
                                }
                            })
                        }
                    </div>
            )
        }
        else {
            if(this.props.onClick == undefined) {
                return (
                    <div className={`d-flex ${this.props.textAlign == undefined ? "justify-content-end" : this.props.textAlign}  align-items-center ${this.props.show_button_group_container_class ? this.props.show_button_group_container_class : 'swot-button-group-container'}`}>
                       {
                           buttonGroupData.map((val, key) => {
                               return (
                                   <NavLink to={val.link} className="swot-nav-link" id={`TooltipExample${val.tooltip_id}`} style={{backgroundImage: `url(${val.img})`,opacity: swotCatagory == val.id? 0.5 : 1, filter: swotCatagory == val.id ? 'grayscale(1)' : 'grayscale(0)'}} key={key}>
                                        <Tooltip placement="top" isOpen={this.state.tooltipOpen && this.state.activeToolTipId == val.tooltip_id} target={`TooltipExample${val.tooltip_id}`} toggle={(e) => this.toggleMultiple(e,val.tooltip_id)} delay={{ show: 0, hide: 5 }}>
                                            {val.name} 
                                        </Tooltip>
                                   </NavLink>
                               )
                           })
                       }
                        </div>
                )
            }
            else {
                return (
                    <div className={`d-flex ${this.props.textAlign == undefined ? "justify-content-end" : this.props.textAlign}  align-items-center ${this.props.show_button_group_container_class ? this.props.show_button_group_container_class : 'swot-button-group-container'}`}>
                       {
                           buttonGroupData.map((val, key) => {
                               return (
                                   <div className="swot-nav-link" id={`TooltipExample${val.tooltip_id}`} style={{backgroundImage: `url(${val.img})`,opacity: swotCatagory == val.id? 0.5 : 1,cursor: "pointer"}} key={key} onClick={() => this.props.onClick(val.id)}>
                                        <Tooltip placement="top" className="toolTipColor" isOpen={this.state.tooltipOpen && this.state.activeToolTipId == val.tooltip_id} target={`TooltipExample${val.tooltip_id}`} toggle={(e) => this.toggleMultiple(e,val.tooltip_id)} delay={{ show: 0, hide: 5 }}>
                                            {val.name} 
                                        </Tooltip>
                                   </div>
                               )
                           })
                       }
                        </div>
                )
            }
        }
    }
}

CircularButtonGroup.propTypes = {
    swotCatagory: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    singleButton: PropTypes.bool,
    buttonGroupData: PropTypes.array,
    textAlign: PropTypes.string,
    toolTip: PropTypes.bool,
    onClick: PropTypes.func,
    uncontrolledButton: PropTypes.bool,
  };

  export default withRouter(CircularButtonGroup)


// WEBPACK FOOTER //
// ./src/_components/common/CircularButtonGroup/index.js